export default __webpack_public_path__ + "static/lea-text-ff0e9e0214ad81675876193e2a116e1f.png";